<script setup lang="ts">
  import { computed, ref } from 'vue'
  import { formatDate, formatDateTime } from '@/common/services/time'

  const props = defineProps({
    value: {
      type: String,
      required: true
    }
  })

  const values = computed<any[]>(() => {
    try {
      const result = JSON.parse(props.value)
      if (Array.isArray(result)) {
        return result
      } else {
        return [result]
      }
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
      // If JSON parsing fails, return the original value as a single item array
      return [props.value]
    }
  })

  const maxValues = 2
  const showAllArrayValues = ref(false)

  const visibleValues = computed(() => {
    if (showAllArrayValues.value) {
      return values.value
    } else {
      return values.value.slice(0, maxValues)
    }
  })
</script>

<template>
  <ul :class="{'list-disc pl-3': values.length > 1}">
    <li v-for="(v, index) in visibleValues" :key="index">
      <template v-if="v !== undefined && v !== null">
        <template v-if="typeof v.startsWith === 'function' && v.startsWith('i18n:')">
          {{ $t(v.substring(5)) }}
        </template>
        <template v-else-if="typeof v.includes === 'function' && v.includes('+0000 UTC')">
          <template v-if="v.includes('00:00:00')">
            {{ formatDate(new Date(v)) }}
          </template>
          <template v-else>
            {{ formatDateTime(new Date(v)) }}
          </template>
        </template>
        <template v-else>
          {{ v }}
        </template>
      </template>
    </li>
  </ul>
  <div v-if="!showAllArrayValues && values.length > maxValues" class="float-left no-underline italic test-2xs cursor-pointer" @click="showAllArrayValues = true">
    + {{ $t('common.actions.show_more_count', { count: values.length - maxValues }) }}
  </div>
</template>